const messages = {
    availPoints: "Galimi taškai",
    awaitingPoints: "Laukiantys taškai",
  board: {
    title: "Valdymo skydelis",
    title2: "Našumo animacija {year}",
    headline1: "Jūsų akcijos ir taškai viename vaizde",
    headline2: "Uždirbkite taškų pirkdami padangas.",
    pointsBalanceToDate: "TAŠKŲ LIKUTIS ŠIAI DIENAI",
    availPoints: "Galimi taškai",
    awaitingPoints: "Laukiantys taškai",
    yourRealisation: "JŪSŲ PASIEKIMAI",
    yourEngagement: "Jūsų metinis įsipareigojimas: <b>{tyres} padangos</b>",
    yourPoints: "JŪSŲ TAŠKAI",
    yourRetailPurchase: "JŪSŲ MAŽMENINĖS PREKYBOS PIRKINIAI",
    yourRetailPurchaseCCS: "JŪSŲ MAŽMENINĖ PARDAVIMAS",
    pointsByPurchase: "taškų, sugeneruotų perkant",
    pointsByBoosters: "stiprintuvų sugeneruotų taškų",
    pointsByBSPurchase: "Taškai, sugeneruoti perkant Bridgestone",
    pointsByBSPurchaseCCS:
      "Taškai, surinkti pardavus Bridgestone padangas",
    remaining: "Likusios padangos",
    yourGoal: "Tikslo progresas",
    unit: "padangos",
    buttons: {
      learnMore: "Sužinokite daugiau apie savo taškus",
      learnMoreAboutMechanism: "Sužinokite daugiau apie mechaniką",
    },
    charts: {
      byBrand: "Pagal prekės ženklą",
      bySize: "Pagal ratlankio<br/>dydį",
    },
    exploreResults: "Atraskite savo rezultatus",
    tyreLimitInfo:
      "Kiekvienam „Booster“ kampanijos laikotarpiui reikalingas mažiausiai 50 „Bridgestone“ ir (arba) „Firestone“ padangų išpardavimas.",
  },
  charts: {
    byBrand: "Pagal prekės ženklą",
    bySize: "pagal ratlankio dydį",
  },

  dashboard: {
    dashboardTitle: "Jūsų privalumai",
    dashboardBox: {
      title: "Taškų balansas",
      description: "Jūsų dabartinių rinkodaros taškų suma",
      availPoints: "Galimi taškai",
      awaitingPoints: "Laukiantys taškai",
      lastUpdate: "Paskutinis atnaujinimas",
      button: "Sužinokite daugiau",
      points: "points",
    },
  },
  soldTyres: "PADANGOS PARDUOTOS",
  receivedPoints: "UŽTIKRINTŲ TAŠKŲ",
  boosterCCS: {
    personalInfo: "Asmeninė informacija",
    csNumberTitle: "Nurodykite dalyvaujančios sąskaitos numerį (-ius)",
    tyresTitle: "Nurodykite parduotų padangų skaičių",
    minTyresInfo:
      "Reikalingos mažiausiai __PAdangos__ Bridgestone/Firestone padangos. Kompensacija taikoma tik Bridgestone padangoms.",
    tyresAmount: "Padangų skaičius",
    filesTitle: "Įkelkite pardavimo įrodymą",
    filesDescription:
      "Atkreipkite dėmesį: bus svarstomi tik pardavimai, kuriuose nurodytas padangos ratlankio dydis.",
    addAnotherFile: "Pridėkite kitą dokumentą",
    file: "Įkelti dokumentą",
    formatInfo:
      "Priimami failų formatai: xlsx, jpeg ir pdf. Maksimalus failo dydis: 8 MB",
    confrimationMessage:
      "<b>Dėkojame už dalyvavimą!</b> <br/>Jūsų užklausa buvo gauta ir persiųsta Bridgestone komandoms patvirtinti.<br/>Gausite pranešimą el. paštu su dalyvavimo Booster CCS rezultatais.<br/>Iki greito susitikimo Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Dalinkitės taškais",
    forShare: "Taškai, kuriuos pasidalinsite",
    title: "Pavadinimas",
  },
  notFoundFile: "Nepasirinkta nė vieno",
  chooseFile: "Pasirinkite failą",
};
export default {
  messages,
};
